import styled from 'styled-components';

import { Button } from '@speeki/global-ui-components';

export const InputWrapper = styled.div`
    align-self: center;
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    margin-bottom: 8px;
    max-height: 52px;
`;

export const InputHolder = styled.div`
    align-items: center;
    cursor: pointer;
    display: flex;
    flex: 1;
    outline: none;
    position: relative;
`;

export const UploadInput = styled.input`
    display: none;
`;

export const UploadButton = styled(Button)`
    line-height: 1;
    min-width: 188px;
    padding: 18px 5px;
`;
